import {Component} from '@angular/core';

@Component({
  templateUrl: './refrigerator-old-budget.component.html'
})
export class RefrigeratorOldBudgetComponent {
  constructor() {
  }
}
